import { useEffect } from 'react';
import { useMotionValue } from 'framer-motion';

// 0 → 1 while a tall sticky section is pinned (measured live, immune to layout shifts)
export const useSectionProgress = (ref) => {
  const progress = useMotionValue(0);
  useEffect(() => {
    const update = () => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const range = r.height - window.innerHeight;
      progress.set(Math.min(1, Math.max(0, -r.top / range)));
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, [ref, progress]);
  return progress;
};
